<template>
  <div class="g-catalogo-filters__mobile">
    <div
      id="catalogue_filters_for_mobile"
      class="filter-button"
      @click="show_mobile_filter = true"
    >
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.333 5.95325V2.49992C13.333 2.32311 13.2627 2.15354 13.1377 2.02851C13.0127 1.90349 12.8431 1.83325 12.6663 1.83325C12.4895 1.83325 12.3199 1.90349 12.1949 2.02851C12.0699 2.15354 11.9996 2.32311 11.9996 2.49992V5.95325C11.6135 6.09339 11.2799 6.349 11.0442 6.68536C10.8084 7.02172 10.682 7.42251 10.682 7.83325C10.682 8.244 10.8084 8.64478 11.0442 8.98114C11.2799 9.3175 11.6135 9.57312 11.9996 9.71325V14.4999C11.9996 14.6767 12.0699 14.8463 12.1949 14.9713C12.3199 15.0963 12.4895 15.1666 12.6663 15.1666C12.8431 15.1666 13.0127 15.0963 13.1377 14.9713C13.2627 14.8463 13.333 14.6767 13.333 14.4999V9.71325C13.7191 9.57312 14.0526 9.3175 14.2884 8.98114C14.5241 8.64478 14.6506 8.244 14.6506 7.83325C14.6506 7.42251 14.5241 7.02172 14.2884 6.68536C14.0526 6.349 13.7191 6.09339 13.333 5.95325ZM12.6663 8.49992C12.5344 8.49992 12.4055 8.46082 12.2959 8.38757C12.1863 8.31431 12.1008 8.21019 12.0504 8.08837C11.9999 7.96656 11.9867 7.83251 12.0124 7.70319C12.0382 7.57387 12.1016 7.45508 12.1949 7.36185C12.2881 7.26861 12.4069 7.20512 12.5362 7.1794C12.6655 7.15367 12.7996 7.16687 12.9214 7.21733C13.0432 7.26779 13.1473 7.35324 13.2206 7.46287C13.2939 7.5725 13.333 7.7014 13.333 7.83325C13.333 8.01006 13.2627 8.17963 13.1377 8.30466C13.0127 8.42968 12.8431 8.49992 12.6663 8.49992ZM8.66628 9.95325V2.49992C8.66628 2.32311 8.59605 2.15354 8.47102 2.02851C8.346 1.90349 8.17643 1.83325 7.99962 1.83325C7.82281 1.83325 7.65324 1.90349 7.52821 2.02851C7.40319 2.15354 7.33295 2.32311 7.33295 2.49992V9.95325C6.94685 10.0934 6.61326 10.349 6.37751 10.6854C6.14177 11.0217 6.0153 11.4225 6.0153 11.8333C6.0153 12.244 6.14177 12.6448 6.37751 12.9811C6.61326 13.3175 6.94685 13.5731 7.33295 13.7133V14.4999C7.33295 14.6767 7.40319 14.8463 7.52821 14.9713C7.65324 15.0963 7.82281 15.1666 7.99962 15.1666C8.17643 15.1666 8.346 15.0963 8.47102 14.9713C8.59605 14.8463 8.66628 14.6767 8.66628 14.4999V13.7133C9.05239 13.5731 9.38598 13.3175 9.62172 12.9811C9.85747 12.6448 9.98394 12.244 9.98394 11.8333C9.98394 11.4225 9.85747 11.0217 9.62172 10.6854C9.38598 10.349 9.05239 10.0934 8.66628 9.95325ZM7.99962 12.4999C7.86776 12.4999 7.73887 12.4608 7.62924 12.3876C7.5196 12.3143 7.43416 12.2102 7.3837 12.0884C7.33324 11.9666 7.32004 11.8325 7.34576 11.7032C7.37148 11.5739 7.43498 11.4551 7.52821 11.3618C7.62145 11.2686 7.74024 11.2051 7.86956 11.1794C7.99888 11.1537 8.13292 11.1669 8.25474 11.2173C8.37656 11.2678 8.48068 11.3532 8.55393 11.4629C8.62718 11.5725 8.66628 11.7014 8.66628 11.8333C8.66628 12.0101 8.59605 12.1796 8.47102 12.3047C8.346 12.4297 8.17643 12.4999 7.99962 12.4999ZM3.99962 4.61992V2.49992C3.99962 2.32311 3.92938 2.15354 3.80436 2.02851C3.67933 1.90349 3.50976 1.83325 3.33295 1.83325C3.15614 1.83325 2.98657 1.90349 2.86155 2.02851C2.73652 2.15354 2.66628 2.32311 2.66628 2.49992V4.61992C2.28018 4.76005 1.94659 5.01567 1.71084 5.35203C1.4751 5.68839 1.34863 6.08917 1.34863 6.49992C1.34863 6.91067 1.4751 7.31145 1.71084 7.64781C1.94659 7.98417 2.28018 8.23978 2.66628 8.37992V14.4999C2.66628 14.6767 2.73652 14.8463 2.86155 14.9713C2.98657 15.0963 3.15614 15.1666 3.33295 15.1666C3.50976 15.1666 3.67933 15.0963 3.80436 14.9713C3.92938 14.8463 3.99962 14.6767 3.99962 14.4999V8.37992C4.38572 8.23978 4.71931 7.98417 4.95506 7.64781C5.1908 7.31145 5.31727 6.91067 5.31727 6.49992C5.31727 6.08917 5.1908 5.68839 4.95506 5.35203C4.71931 5.01567 4.38572 4.76005 3.99962 4.61992ZM3.33295 7.16659C3.2011 7.16659 3.0722 7.12749 2.96257 7.05423C2.85294 6.98098 2.76749 6.87686 2.71703 6.75504C2.66657 6.63322 2.65337 6.49918 2.67909 6.36986C2.70482 6.24054 2.76831 6.12175 2.86155 6.02851C2.95478 5.93528 3.07357 5.87179 3.20289 5.84606C3.33221 5.82034 3.46626 5.83354 3.58807 5.884C3.70989 5.93446 3.81401 6.01991 3.88726 6.12954C3.96052 6.23917 3.99962 6.36806 3.99962 6.49992C3.99962 6.67673 3.92938 6.8463 3.80436 6.97132C3.67933 7.09635 3.50976 7.16659 3.33295 7.16659Z"
          fill="#424142"
        />
      </svg>

      Filtrar
    </div>
    <div v-if="show_mobile_filter" class="filter-overlay">
      <div class="filter-overlay__topbar">
        <div class="filter-overlay__topbar__label">
          <svg
            @click="show_mobile_filter = false"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            width="12"
            height="12"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          <span>Filtro</span>
        </div>
        <span @click="show_mobile_filter = false">
          <div
            data-v-711e01df=""
            class="close-btn text-2xl text-black ml-2 font-sans flex items-center"
          >
            <span data-v-711e01df=""></span>
            <span data-v-711e01df=""></span>
          </div>
        </span>
      </div>
      <div
        v-for="filter in filters"
        class="filter-overlay__item"
        @click="show_filter_contents = filter"
      >
        <div class="filter-overlay__filter-label" id="filter_label">
          {{ filter }}
          <svg
            v-show="show_filter_contents === filter"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            width="12"
            height="12"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 15l7-7 7 7"
            />
          </svg>
          <svg
            v-show="show_filter_contents !== filter"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            width="12"
            height="12"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>

        <div
          v-if="show_filter_contents === filter"
          class="filter-overlay__filter-content"
        >
          <div v-if="show_filter_contents === 'Precio'">
            <price-filter @close="close()" :currencySymbol="myList.currencySymbol" />
          </div>
          <!--<div v-if="show_filter_contents === 'Marca'">
            <brand-filter @close="close()" />
          </div>-->
          <div v-if="show_filter_contents === 'Valor'">
            <rating-filter @close="close()" />
          </div>
          <div v-if="show_filter_contents === 'Vendedor'">
            <retailer-filter @close="close()" />
          </div>
          <div v-if="show_filter_contents === 'Etiquetas'">
            <div v-for="tag in tags">
              <tag-filter :tag="tag" @close="close()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PriceFilter from "../../../components/PriceFilter";
import BrandFilter from "../../../components/BrandFilter";
import RatingFilter from "../../../components/RatingFilter";
import { mapGetters } from "vuex";
import RetailerFilter from "../../../components/RetailerFilter";
import TagFilter from "../../../components/TagFilter";

export default {
  name: "CatalogueMobileFilters",
  components: {
    "price-filter": PriceFilter,
    "brand-filter": BrandFilter,
    "rating-filter": RatingFilter,
    "retailer-filter": RetailerFilter,
    "tag-filter": TagFilter,
  },
  data() {
    return {
      show_mobile_filter: false,
      show_filter_contents: null,
    };
  },
  computed: {
    ...mapGetters({
      tags: "tags",
      waitingFilters: "waitingFilters"
    }),
    showTagsFilters() {
      return (
        this.tags.length > 0 &&
        !this.waitingFilters
      );
    },
    filters() {
      if (this.showTagsFilters) {
        //return ["Precio", "Marca", "Valor", "Vendedor", "Etiquetas"];
        return ["Precio", "Valor", "Vendedor", "Etiquetas"];
      }
      return ["Precio", "Valor", "Vendedor"];
      //return ["Precio", "Marca", "Valor", "Vendedor"];
    },
  },
  methods: {
    close() {
      this.show_mobile_filter = false
      this.show_filter_contents = null
    }
  },
};
</script>
